import React from "react";
import type { ButtonProps } from "./Button.types";

const getVariantClasses = (variant: ButtonProps["variant"]) => {
  const variants = {
    primary:
      "bg-brand text-surface hover:bg-brand-muted focus:ring-brand/50",
    secondary:
      "bg-surface/10 text-white hover:bg-surface/15 focus:ring-white/30",
    danger:
      "bg-danger/90 text-white hover:bg-danger focus:ring-danger/50",
    ghost: "text-white/70 hover:bg-surface/10 hover:text-white focus:ring-white/20",
  };
  return variants[variant];
};

const getSizeClasses = (size: ButtonProps["size"]) => {
  const sizes = {
    sm: "h-8 px-3 text-sm rounded-[10px]",
    md: "h-10 px-4 text-sm rounded-[14px]",
    lg: "h-12 px-6 text-base rounded-[14px]",
  };
  return sizes[size];
};

export const Button: React.FC<ButtonProps> = ({
  variant,
  size,
  children,
  onClick,
  disabled = false,
  loading = false,
  type = "button",
  className = "",
  ...props
}) => {
  const baseClasses =
    "inline-flex items-center justify-center font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-page disabled:opacity-50 disabled:cursor-not-allowed";
  const buttonClasses = `${baseClasses} ${getVariantClasses(variant)} ${getSizeClasses(size)} ${className}`;

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg
          className="animate-spin -ml-1 mr-2 h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
};
